module.exports = __webpack_public_path__ + "8a64d6c766abc247309634cb5bf89414.pdf";